<template>
  <div class="page-main common">
    <a-tabs>
      <a-tab-pane tab="个人信息资料">
        <div class="common-form-inline">
          <a-form-model
            ref="form"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item label="手机号" prop="phone">
                  <a-input v-model="form.phone" :maxLength="11" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="用户姓名" prop="name">
                  <a-input v-model="form.name" :maxLength="20" :disabled="isDetail" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item label="身份证号" prop="certificateNo">
                  <a-input
                    v-model="form.certificateNo"
                    :maxLength="50"
                    :disabled="isDetail"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="有效期限" prop="documentStartDate">
                  <a-date-picker
                    style="width: 120px"
                    valueFormat="yyyy-MM-DD"
                    v-model="form.documentStartDate"
                  />
                  ~
                  <a-date-picker
                    style="width: 120px; margin-right: 10px"
                    valueFormat="yyyy-MM-DD"
                    v-model="form.documentEndDate"
                    :disabled="form.longTermStatus"
                  />
                  <a-checkbox
                    v-model="form.longTermStatus"
                    @change="longTermStatusChange"
                  >
                    长期
                  </a-checkbox>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item label="身份证影像" prop="IDcardFlag">
                  <div class="spaceLeft" style="width: 500px">
                    <div>
                      <imgUpload
                        :file="IDcardzheng"
                        :disabled="isDetail"
                        @remove="removeOk"
                        :paramObj="paramObj1"
                        @uploadOk="uploadOk"
                        text="上传证件正面"
                        name="file"
                      ></imgUpload>
                    </div>
                    <div>
                      <imgUpload
                        :disabled="isDetail"
                        :file="IDcardfan"
                        @remove="removeOk"
                        :paramObj="paramObj2"
                        @uploadOk="uploadOk"
                        text="上传证件背面"
                        name="file"
                      ></imgUpload>
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </a-tab-pane>
    </a-tabs>
    <div class="spaceCenter model-footer-btns">
      <a-button @click="goback" class="btn-blue-line btn-big">返回</a-button>
      <a-button v-if="!isDetail" @click="save" class="btn-big" type="primary"
        >保存</a-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getUserInfo, certificationSubmit } from "@/api/security.js";
import { fileSaveAPI, fileQuery } from "@/api/file.js";
import imgUpload from "@/components/ui/img-upload/img-upload";
export default {
  components: { imgUpload },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      orgCode: "",
      form: {
        phone: undefined,
        name: undefined,
        certificateNo: undefined,
        documentStartDate: undefined,
        documentEndDate: "",
        longTermStatus: undefined,
        IDcardFlag: false,
      },
      IDcardzheng: {},
      IDcardfan: {},
      rules: {
        phone: {
          required: true,
          message: "请填写手机号",
        },
        name: {
          required: true,
          message: "请填写用户姓名",
        },
        certificateNo: {
          required: true,
          trigger: "blur",
          validator: (rule, value, cbfn) => {
            if (!value) {
              cbfn("请填写身份证号");
            } else if (!this.utils.regExpObj.IDCARD_PATTERN.test(value)) {
              cbfn("身份证格式不正确");
            }
            cbfn();
          },
        },
        documentStartDate: {
          required: true,
          required: true,
          validator: (rule, value, cbfn) => {
            if (this.form.longTermStatus) {
              if (!this.form.documentStartDate) {
                cbfn("请选择有效期限");
              } else {
                cbfn();
              }
            } else {
              if (!this.form.documentStartDate || !this.form.documentEndDate) {
                cbfn("请选择有效期限");
              } else {
                cbfn();
              }
            }
          },
        },
        IDcardFlag: {
          required: true,
          validator: (rule, value, cbfn) => {
            if (!(this.IDcardzheng.fileId && this.IDcardfan.fileId)) {
              cbfn("请上传身份证影像");
            } else {
              cbfn();
            }
          },
        },
      },
      isDetail: false,
      paramObj1: {
        app: "portal-pc",
        module: "personalAuthentication",
        user: "",
        tblBlId: "",
        suprFileId: "0",
        mdlId: "personIDcardzheng",
      },
      paramObj2: {
        app: "portal-pc",
        module: "personalAuthentication",
        user: "",
        tblBlId: "",
        suprFileId: "1",
        mdlId: "personIDcardfan",
      },
    };
  },
  computed: {
    ...mapGetters({
      sessionData: "home/getSessionData",
      userObj: "home/getUserObj",
    }),
  },
  created() {
    this.paramObj1.tblBlId = this.sessionData.userNum;
    this.paramObj2.tblBlId = this.sessionData.userNum;
    this.isDetail = this.$route.query.mode === "info";
    if (this.userObj.status === "0") {
      this.form.phone = this.sessionData.mobile;
    } else {
      this.form.phone = this.userObj.phone;
      this.form.name = this.userObj.name;
      this.form.certificateNo = this.userObj.certificateNo;
      this.form.documentStartDate = this.userObj.documentStartDate;
      this.form.documentEndDate =
        this.userObj.documentEndDate === null ? "" : this.userObj.documentEndDate;
      this.form.longTermStatus = this.userObj.longTermStatus == 1 ? true : false;
      this.getFile({
        mdlId: "personIDcardzheng",
        tblBlId: this.userObj.bigTreeId,
        // suprFileId: "0",
      });
      this.getFile({
        mdlId: "personIDcardfan",
        tblBlId: this.userObj.bigTreeId,
        // suprFileId: "1",
      });
      
    }
  },
  methods: {
    getFile(fileParams) {
      fileQuery(fileParams).then((resp) => {
        if (fileParams.mdlId === "personIDcardzheng") {
          this.IDcardzheng = resp.data.grid.list[0]
        } else {
          this.IDcardfan = resp.data.grid.list[0]
        }
      });
    },
    longTermStatusChange() {
      this.form.documentEndDate = "";
      this.$refs.form.validateField("documentStartDate");
    },
    goback() {
      this.$router.go(-1);
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          certificationSubmit({
            phone: this.form.phone,
            name: this.form.name,
            certificateNo: this.form.certificateNo,
            documentStartDate: this.form.documentStartDate,
            documentEndDate: this.form.documentEndDate,
            longTermStatus: this.form.longTermStatus ? 1 : 0,
          }).then((res) => {
            this.$message.success("提交成功");
            this.$router.replace("/security/personalAuthentication");
          });
        }
      });
    },
    removeOk(file) {
      if (file.uid === this.IDcardzheng.fileId) {
        this.IDcardzheng = {};
      } else if (file.uid === this.IDcardfan.fileId) {
        this.IDcardfan = {};
      }
    },
    uploadOk(data, fileParams) {
      const saveParams = {
        mdlId: fileParams.mdlId,
        tblBlId: fileParams.tblBlId,
        suprFileId: fileParams.suprFileId,
        fileTpCd: 9,
        id: data[0] && data[0].id,
        fileExpdNm: data[0] && data[0].fileExpdNm,
        fileNm: data[0] && data[0].name,
        fileRte: data[0] && data[0].fileRte,
        fileSize: data[0] && data[0].size,
      };
      fileSaveAPI(saveParams)
        .then((res) => {
          this.$message.success("上传成功");
          fileQuery({
            mdlId: fileParams.mdlId,
            tblBlId: fileParams.tblBlId,
            suprFileId: fileParams.suprFileId,
          }).then((resp) => {
            if (fileParams.mdlId === "personIDcardzheng") {
              this.IDcardzheng = {
                ...saveParams,
                fileId: data[0] && data[0].uid,
                id: resp.data[0] && resp.data[0].id,
              };
            } else {
              this.IDcardfan = {
                ...saveParams,
                fileId: data[0] && data[0].uid,
                id: resp.data[0] && resp.data[0].id,
              };
            }
            this.$refs.form.validateField("IDcardFlag");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.form-input-len {
  font-size: 12px;
  color: #666;
  position: absolute;
  right: 0;
  top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/security/personalAuthentication/editPage.vue